/**
 * The feature that turns Session Recap on for a member. Mirrors
 * SESSION_RECAP_FEATURE in @volley/data, which the browser bundle can't import
 * a value from without pulling in all of it.
 */
export const SESSION_RECAP_FEATURE = "SESSION_RECAP";
